// Runtime env accessor.
//
// In production the config is injected at container start into window.__APP_ENV__
// by /config.js (rendered by docker-entrypoint.sh from Vault-sourced env vars).
// In dev there is no rendered config.js, so we fall back to CRA's build-time
// process.env.* (statically inlined by webpack — hence each key is read explicitly
// below; dynamic process.env[key] access is NOT inlined by CRA).
//
// `{ ...buildtime, ...runtime }`: in production buildtime is all-undefined and the
// runtime (Vault) values win; in dev runtime is empty and the build-time values are used.

const buildtime: Record<string, string | undefined> = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_DATA_API_URL: process.env.REACT_APP_DATA_API_URL,
  REACT_APP_OCPP_LOGS_API_URL: process.env.REACT_APP_OCPP_LOGS_API_URL,
  REACT_APP_QRCODE_API_URL: process.env.REACT_APP_QRCODE_API_URL,
  REACT_APP_ENV_NAME: process.env.REACT_APP_ENV_NAME,
  REACT_APP_UPTIME_URL: process.env.REACT_APP_UPTIME_URL,
  REACT_APP_UPTIME_HEIGHT: process.env.REACT_APP_UPTIME_HEIGHT,
  REACT_APP_DETAILED_UPTIME_URL: process.env.REACT_APP_DETAILED_UPTIME_URL,
  REACT_APP_DETAILED_UPTIME_HEIGHT: process.env.REACT_APP_DETAILED_UPTIME_HEIGHT,
  REACT_APP_FRESHPING_IDS: process.env.REACT_APP_FRESHPING_IDS,
  REACT_APP_IS_DEVELOPMENT: process.env.REACT_APP_IS_DEVELOPMENT,
  REACT_APP_SHOW_ENV_NAME: process.env.REACT_APP_SHOW_ENV_NAME,
  REACT_APP_TUPI_COMPANY_ID: process.env.REACT_APP_TUPI_COMPANY_ID,
  REACT_APP_SHELL_COMPANY_ID: process.env.REACT_APP_SHELL_COMPANY_ID,
  REACT_APP_FIREBASE_CONFIG: process.env.REACT_APP_FIREBASE_CONFIG,
  REACT_APP_CPMS_URL: process.env.REACT_APP_CPMS_URL,
  REACT_APP_EMSP_WEB_URL: process.env.REACT_APP_EMSP_WEB_URL,
  REACT_APP_COMPANY_IDS_FOR_CONTA_AZUL_TEST:
    process.env.REACT_APP_COMPANY_IDS_FOR_CONTA_AZUL_TEST,
  REACT_APP_CONTA_AZUL_REDIRECT_URI:
    process.env.REACT_APP_CONTA_AZUL_REDIRECT_URI,
  REACT_APP_AMPLITUDE_API_KEY: process.env.REACT_APP_AMPLITUDE_API_KEY,
};

const runtime: Record<string, string | undefined> =
  (globalThis as unknown as { __APP_ENV__?: Record<string, string> }).__APP_ENV__ || {};

export const appEnv: Record<string, string | undefined> = {
  ...buildtime,
  ...runtime,
};
